import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

const DropdownButton = ({ text, onClick }) => (
  <Button
    grey
    onClick={onClick}
  >
    {text} <MaterialIcon id={'arrow_drop_down'} />
  </Button>
);

DropdownButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
};

export default DropdownButton;
